import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Menu } from 'src/app/models/shared/menu';
import { MenuItemService } from './menu-item.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.css']
})
export class MenuItemComponent implements OnInit {
  @Input() item: Menu;

  protected navbarSelected: number = 1;
  protected navbarSecondarySelected: number = -1;

  constructor(
    private readonly menuItemService: MenuItemService,
  ) {

  }

  public ngOnInit(): void {
    this.setNavbarSelected();
    //this.setNavbarSecondarySelected();
  }

  private setNavbarSelected(): void {
    /** For when user select navbar manuality, get the value of navbar select */
    this.menuItemService.getsetNavbarSelectAction$.pipe(
      tap((isShow) => { this.navbarSelected = isShow; })
    ).subscribe();

    /** For refresh page or is init, get the value of navbar select */
    if(!localStorage.getItem('navBarSelect')) { localStorage.setItem('navBarSelect', '1') }
    this.navbarSelected = parseInt(localStorage.getItem('navBarSelect'));
  }

  private setNavbarSecondarySelected(): void {
    /** For when user select navbar manuality, get the value of navbar select */
    this.menuItemService.getsetNavbarSelectSecondaryAction$.pipe(
      tap((isShow) => { this.navbarSecondarySelected = isShow; })
    ).subscribe();

    /** For refresh page or is init, get the value of navbar select */
    if(!localStorage.getItem('navBarSecondarySelect')) { localStorage.setItem('navBarSecondarySelect', '-1') }
    this.navbarSecondarySelected = parseInt(localStorage.getItem('navBarSecondarySelect'));
  }

}
